import React from 'react'
import "./Faq.css";
import Faq from "react-faq-component";

const data = {
    
    rows: [
        {
            title: "Why should I do my web design and development from NJS Solutions?",
            content: `NJS Solutions is a leading web design company in India with 10+ years of experience and 16 international awards to its credit. We also have experience working for many leading MNCs for their web design and development projects. NJS Solutions operates from its 6 offices across India and has worked on more than 1000+ web design projects for our clients across the globe, from more than 80 countries.
            
            At NJS Solutions, we’re always obsessed to deliver world-class quality projects and this has definitely helped us make a name for ourselves in the web development India arena, by winning multiple international awards in the last 10 years (consistently every year right from 2012 to 2021).`,
        },
        {
            title: "Why is India an ideal choice for web development outsourcing?",
            content:`
                India is the most sought-after destination for web design outsourcing for decades, mainly because of its ‘cost of quality' advantage. You will get world-class projects delivered from web development companies in India at a fraction of what you pay in the Americas or Europe for a similar project.
                
                India has a huge pool of talent that enables both companies and individuals to grab the opportunity for creating fabulous and innovative websites and applications using the latest and advanced technologies. We've put together an article that details more about the benefits of website design outsourcing to India compared to some other destinations.`
        },
        {
            title: "How to find the best web design company in India?",
            content: `It would be difficult to find the best web design company India, if you didn't approach it in the right way. There are thousands of companies and everyone claims to offer the same level of service. But it's up to you to do some research on the company that you're considering - especially on their previous works, their credentials, their clients, etc then just compare based on their price. After all, all Indian companies charge a reasonable amount and you don't have to go for the cheapest and compromise on all the other important aspects of your web designing project.

            Here's a nice piece we've written sometime back on how to find the best web design company in India. At NJS Solutions we charge only reasonable rates for our world-class quality works, and this makes us stand apart in the web design India companies list. `,
        },
        {
            title: "How much does it cost to hire a web developer in India?",
            content: `You can hire a web development company in India on a per-project basis, where the cost of the project completely depends on the scope of the project. When you hire on a per-project basis various teams (UX and web designers, front-end developers, back-end developers, testers, etc) would be involved in your project at different stages and there will also be a dedicated project manager assigned.

            Another option is to hire a dedicated web developer in India on a monthly basis. In this model, the web developer (or web designer or front-end developer) would be working exclusively on your project and all works/tasks will be assigned directly by you. The pricing here would be hourly and usually calculated on a monthly basis.
            At NJS Solutions, we do offer both of these models.,`
        },
        {
            title: "Do you do custom website design or use pre-built templates?",
            content: `We are a multiple international award-winning website design company in India, that always loves to build top-class custom design websites. We have a dedicated team of award-winning web designers who are capable of visualizing astounding custom-designed websites for our customers, based on their business objectives and target audience, and have been successfully doing this since 2011. We always suggest going with a custom-designed website as it would be more impactful since it's tailor-made exclusively for you. However, if you're constrained with time and/or budget, we can work on customizing some pre-existing templates too for you.

            If you're still confused between choosing a custom web design or a template option, we have written a blog on custom design websites vs pre-made templates that might give you some more insights on this.`
        },
        {
            title: "In which technology should I do my web development?",
            content: `The technology that you should choose for your web design and web development projects completely depends on the type of project.

            As a leading web development company in India, we work on a bunch of technology stacks, though below are some recommended ones:
            So if it's a normal informational website, you can go with any leading CMS like WordPress (or Joomla/ Drupal) and if it's an eCommerce we suggest going with Magento or WooCommerce. If it's a custom web application development, you could consider going with the latest trending technologies like MERN stack or MEAN stack. Kotlin for Android and Swift for iOS for native mobile apps and Flutter or React Native for hybrid mobile app development are the recommended options.
            
            Having said that, as the technology opted depends on your requirement and audience targeted, we normally offer a free primary consultation on which technology you should opt for your web designing or development requirement. Just contact us with your requirements for the same!`
        },
    ],
};

const config = {
    animate: true,
    arrowIcon: "V",
    openOnload: 0,
    expandIcon: "+",
    collapseIcon: "-",
};


const Faqdata = () => {
  return (
    <section class="faqs">

        <div class="container">

            <h2>FAQs</h2>
            <div class="faqs-items-wrap">
                <div class="faqs-item">
                <Faq data={data} config={config}/>


                    
                    
                </div>
               
                
                
        
            </div>
        </div>

    </section>
  )
}

export default Faqdata
